import { useTranslation } from 'react-i18next'
import { FaTrashAlt } from 'react-icons/fa'
import {Button, Grid, Tooltip } from '@mui/material'
import { cloneDeep } from 'lodash'
import { useField, useFormikContext } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import { IRubricCriterion } from 'types'
import _ from 'lodash'
import { useEffect } from 'react'
import SelectField from 'components/atoms/fields/SelectField'
import { useGET_measuresSelectQuery, useLazyGET_measureGenerateRubricSectionsQuery } from 'redux/api/goalbankApi'


const RubricCriterionRow = ({ fieldProps, index, rubric_criterion, disabled, cells=3 }) => {
  const { t } = useTranslation()

  const [field] = useField<IRubricCriterion[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext()

  const [generateRubricSectionsTrigger, {data: generateRubricSectionsResult}] = useLazyGET_measureGenerateRubricSectionsQuery()

  useEffect(() => {
    if(generateRubricSectionsResult) {
        updateCriterion(index, {
            rubric_sections: field.value.find((rc, rcIdx) => rcIdx === index).rubric_sections.map(
                (rs, idx) => { return { 
                    ...rs,
                    title: generateRubricSectionsResult.rubric_sections[idx]
                } })
        })
    }
  }, [generateRubricSectionsResult])


  const updateCriterion = (idx, data) => {
    setFieldValue(fieldProps.name, field.value.map((rc, rcIdx) => { 
      if(idx === rcIdx){
        return { 
          ...rc,
          ...data
        }
      }else
        return rc
    }))
  }

  const updateSection = (criterionIdx, sectionIdx, data) => {
    updateCriterion(criterionIdx, {rubric_sections: field.value.find((rc, rcIdx) => rcIdx === criterionIdx).rubric_sections.map(
      (rs, rsIdx) => { 
        if(rsIdx === sectionIdx){
          return { 
            ...rs,
            ...data
          }
        }else
          return rs
      }
    )})
  }

  const handleRemoveEntity = (index: number) => {
    // Clone the original array
    const entities = cloneDeep(field.value)
    // Entity from array
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }


  return (
    <>            
          <Grid
            container
            spacing={4}
            key={index}
            sx={{
              borderBottom: '1px solid #ccc',
              marginBottom: '40px',
              paddingBottom: '40px'
            }}
          >
            <Grid item xs={12} md={12}>
                  <SelectField
                      valueSelector='benchmark'
                      fieldProps={{
                        label: t('common.benchmark'),
                        name: `${fieldProps.name}[${index}]`,
                        required: true,
                      }}
                      apiCall={useGET_measuresSelectQuery}
                      onChange={(value) => {
                        if(value){
                          let title = ""
                          const parts = value.benchmark.title.split(" ")
                          if(parts.length==1) {
                            title = value.benchmark.title
                          }
                          else {
                            title = parts.filter((p,idx) => idx > 0).join(" ")
                          }
                          setFieldValue(`${fieldProps.name}[${index}]['title']`, title)
                          generateRubricSectionsTrigger({id: value.benchmark.id, cells: cells})
                        } 
                      }}
                      disabled={disabled}
                    />
            </Grid>
            <Grid item xs={12} md={12}>
              <InputField
                valueSelector='title'
                fieldProps={{
                  label: t('rubrics.criterion-title'),
                  name: `${fieldProps.name}[${index}]`,
                  required: true,
                }}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={12}>
                
                <div style={{ display: 'flex', gap: '20px', marginBottom: '20pxx' }}>
                {
                    rubric_criterion.rubric_sections.map((rs, idx) => 
                      <div key={idx} style={{ flexGrow: 1}}>

                          <textarea 
                            value={rs.title}
                            onChange={(e) => {
                              updateSection(index, idx, {title: e.target.value})
                            }}
                            placeholder={`${t('common.level')} ${idx+1}`} 
                            style={{ width: '100%', height: '100px', padding: '10px'}} />
                      
                          <div style={{ marginTop: '10px', display: 'flex', gap: '5px', alignItems: 'center'}}>
                            <div>{t('rubrics.points')}:</div>
                            <div><input 
                              type="number" 
                              value={rs.points} 
                              onChange={(e) => {
                                updateSection(index, idx, {points: parseInt(e.target.value)})
                              }}
                              style={{ width: '50px', height: '34px', textAlign: 'center' }} 
                              /></div>
                            <div>
                                {Math.ceil((rs.points / _.maxBy(rubric_criterion.rubric_sections ?? [], 'points')['points']) * 100)}%
                            </div>
                          </div>
                      
                      </div>  
                    )
                }
                </div>
     
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex' }}>
                <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
                  <Button
                    onClick={() => handleRemoveEntity(index)}
                    aria-label={t('rubrics.delete-criterion')}
                    size='small'
                    disabled={disabled}
                    color='error'
                    variant='outlined'
                    sx={{
                      margin: '0',
                      boxShadow: 'none',
                    }}
                  >
                    <FaTrashAlt style={{ fontSize: '1.2rem' }} /> {t('rubrics.delete-criterion')}
                  </Button>
                </Tooltip>
            </Grid>
          </Grid>
    </>
  )
}

export default RubricCriterionRow
